import { useCallback } from 'react';

import { useRoutesContext } from '../';

export const useDeleteRoutes = () => {
  const { routes } = useRoutesContext();

  const deleteRoutes = useCallback(() => {
    routes?.forEach((route) => {
      route.delete();
    });
  }, [routes]);

  return deleteRoutes;
};
